import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, VStack } from 'native-base';

import { Text } from '@pimm/base';

type PopoverTooltipCompletedProps = Omit<ComponentProps<typeof Popover>, 'children'> & {
  isManual: boolean;
};

export const PopoverTooltipCompleted = (props: PopoverTooltipCompletedProps) => {
  const { t } = useTranslation();

  return (
    <Popover isKeyboardDismissable _backdrop={{ bg: 'black' }} {...props}>
      <Popover.Content accessibilityLabel="Position Actions Tooltip" rounded="lg" bg="white" borderWidth={0}>
        <Popover.Arrow zIndex={1} borderWidth={0} borderColor="white" bg="white" />
        <Popover.Body py={3} px={4} w="320" borderWidth={0} bg="white">
          <VStack space={2}>
            <Text size="lg" fontWeight={600} color="black" lineHeight="xs" mb={2}>
              {props.isManual ? t('app_insights:manual_completion') : t('app_insights:auto_completion')}
            </Text>

            <Text size="md" fontWeight={500} color="gray.700" numberOfLines={3} lineHeight="sm" lineBreakMode="tail">
              {props.isManual ? t('app_insights:manual_completion_message') : t('app_insights:auto_completion_message')}
            </Text>
          </VStack>
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
};
